import React from "react";
import { connect } from "dva";
import { templateConfig, reduxTemplateConfig } from "./config";
import { framework_tool, component_tool } from "@/tool";
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizBrowserExport,WizModal } = component_tool;
class ExamTemplateGroup extends WizContainer {
  componentName = "examTemplateGroup";

  constructor(props) {
    super(props);
    this.state = {};
  }

  _handleDelete(nextProps, nextState, key){
    let o = nextProps[key]
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      WizModal.success({
        title:'操作结果',
        content:<p style={{whiteSpace: "pre-line"}}>{str}</p>
      })
      return true;
    } else {
      wizNotice.error("操作失败，请联系相关人员")
      return false;
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o["success"]) {
      wizNotice.success(o["msg"]);
      return true;
    } else {
      wizNotice.error(o["msg"]);
      return false;
    }
  }

  _handleCategoryList(nextProps, nextState, key) {
    let o = nextProps[key];
    if (o.success) {
      let f = (vs) => {
        vs &&
          vs.length &&
          vs.forEach((v) => {
            v.code = v.id;
            v.codeName = v.name;
          });
      };
      f(o.data);
      return true;
    } else {
      wizNotice.error(o.msg);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key];
    let columnDefs = [
      {
        headerName: "",
        width: 30,
        field: "rowIndex",
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: "center",
          padding: "5px 0",
          color: "#595959",
          backgroundColor: "#f0f0f0",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "500",
          boxShadow: "0 2px 0px 0 rgba(0,0,0,0.15)",
        },
      },
      {
        headerName: "模版组名称",
        field: "title",
        width: 20,
        cellStyle: {
          textAlign: "center",
          padding: "5px 0",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "可见对象",
        field: "target",
        width: 100,
        cellStyle: {
          padding: "5px 0",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left", wrapText: true },
        },
      },
      {
        headerName: "考试分类",
        field: "categoryType",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "考试时长(分钟)",
        field: "limitMinutes",
        width: 20,
        cellStyle: {
          textAlign: "center",
        },
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: "允许重复考试次数",
        field: "count",
        width: 20,
        style: {
          alignment: { vertical: "bottom", horizontal: "left" },
        },
      },
      {
        headerName: '状态',
        field: 'status',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }
    ];
    if (o["success"]) {
      let data = o["data"];
      let _data = []
      data && data.forEach(d => {
        let examTemplateAuthInfo = d['examTemplateAuthInfo']
        let _d = { ...d }
        delete _d['status']
        _d['status'] = d['status'] === 1 ? '有效' : '无效'
        let authData = d['authData']
        let target = ''
        if (authData && Object.keys(authData)) {
          if (authData['orgIds'] && authData['orgIds'].length) {
            target += ' 组织范围：'
            authData['orgIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionIds'] && authData['positionIds'].length) {
            target += ' 岗位：'
            authData['positionIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['positionCategoryIds'] && authData['positionCategoryIds'].length) {
            target += ' 岗位分类：'
            authData['positionCategoryIds'].forEach(org => {
              target += org['name'] + ','
            });
            target += '\n'
          }
          if (authData['personIds'] && authData['personIds'].length) {
            target += ' 指定人员：'
            authData['personIds'].forEach(org => {
              target += org['userName'] +'('+org['fullName'] +'),'
            });
            target += '\n'
          }
        }
        _d['target'] = target
        if (examTemplateAuthInfo && examTemplateAuthInfo.length) {
          for (let i = 0; i < examTemplateAuthInfo.length; i++) {
            const info = examTemplateAuthInfo[i];
            let f = true;
            columnDefs.forEach(c => {
              if (c['field'] === `template_${i + 1}`) {
                f = false;
              }
            });
            if (f) {
              columnDefs.push(
                {
                  headerName: `关联考试模版${i + 1}`,
                  field: `template_${i + 1}`,
                  width: 30,
                  style: {
                    alignment: { vertical: "bottom", horizontal: "left" },
                  }
                }
              )
            }
            _d[`template_${i + 1}`] = info['templateName']
          }
        }
        _data.push(_d)
      });
      WizBrowserExport({
        title: "考试模版组信息",
        sheetName: "考试模版组信息",
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: "考试模版组信息.xlsx",
      });
      return true;
    } else {
      wizNotice.error(o["msg"]);
      return false;
    }
  }

  _render() {
    let _reduxTemplateCofig = reduxTemplateConfig({
      templateConfig,
      apiDataFormat: {
        categoryList: this._handleCategoryList,
        delete: this._handleDelete,
        enable: this._handleCMD,
        export: this._handleFile,
      },
    });
    return <WizReduxTemplate {..._reduxTemplateCofig} />;
  }
}
const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps)(ExamTemplateGroup);
